import React from "react";
import { Link } from "gatsby";
import styled from "styled-components";

// Components
import { Exhibitions } from "./exhibitions";
import { Artists } from "./artists";
import { Fairs } from "./fairs";

const Nav = styled.nav`
  @media (max-width: 767px) {
    margin: 0 0 40px 0;
  }

  & ol {
    & li {
      & a {
        transition: 250ms color ease;

        & span {
          opacity: 0;
          transition: 250ms opacity ease;
        }

        &:hover,
        &.current {
          color: #6f6d6d;

          & span {
            opacity: 1;
          }
        }
      }
    }
  }
`;

export const Navigation = ({
  hideArtists,
  hideExhibitions,
  showExhibitions,
  showArtists,
  showFairs,
  hideFairs,
  showExhibitionsBackButton,
  showFairsBackButton,
  year,
}) => {
  return (
    <Nav>
      <ol>
        {hideArtists !== true && (
          <li>
            <Link to={`/artists/`} activeClassName="current">
              Artists <span className="active-page"> ←</span>
            </Link>

            {showArtists === true && <Artists />}
          </li>
        )}

        {showExhibitionsBackButton === true ? (
          <li className="back-button">
            <Link to={`/exhibitions/`}>
              Back <span className="active-page"> ←</span>
            </Link>
          </li>
        ) : (
          <>
            {hideExhibitions !== true && (
              <li>
                <Link to={`/exhibitions/`} activeClassName="current">
                  Exhibitions <span className="active-page"> ←</span>
                </Link>

                {showExhibitions === true && <Exhibitions />}
              </li>
            )}
          </>
        )}

        {showFairsBackButton === true ? (
          <li className="back-button">
            <Link to={`/fairs/`}>
              Back <span className="active-page"> ←</span>
            </Link>
          </li>
        ) : (
          <>
            {hideFairs !== true && (
              <li>
                <Link to={`/fairs/`} activeClassName="current">
                  Fairs <span className="active-page"> ←</span>
                </Link>

                {showFairs === true && <Fairs />}
              </li>
            )}
          </>
        )}

        <li>
          <Link to={`/contact/`} activeClassName="current">
            Contact <span className="active-page"> ←</span>
          </Link>
        </li>
      </ol>
    </Nav>
  );
};
